import { Component } from '@angular/core';
import { TranslatePipe } from "@ngx-translate/core";
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'app-success',
  standalone: true,
  imports: [
    TranslatePipe,
    NgOptimizedImage
  ],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {
}
